import create from "zustand";
import { persist } from 'zustand/middleware';
import { useAuthStore } from "../auth/auth";
import { Owner } from "../../types/Owner";
import { getAllOwners } from "../../api/owners/getAllOwners";

interface OwnerStore {
    owners: Owner[];
    loading: boolean;
    error: string | null;
    fetchOwners: (page: number, pageSize: number) => Promise<void>;
}

export const useOwnerStore = create<OwnerStore>()(
    persist(
        (set, get) => ({
            owners: [],
            loading: false,
            error: null,
            fetchOwners: async (page: number, pageSize: number) => {
                const { SmartDVRToken, user } = useAuthStore.getState();
                if (!user || !SmartDVRToken) {
                    set({ error: 'User or token information is missing.' });
                    return;
                }

                set({ loading: true, error: null });

                try {
                    const response = await getAllOwners(SmartDVRToken, user.login, page, pageSize);
                    const owners = response || [];
                    set({ owners, loading: false, error: null });
                } catch (error) {
                    console.error('Error fetching owners:', error);
                    set({
                        loading: false,
                        error: error instanceof Error ? error.message : 'Failed to fetch owners'
                    });
                }
            },
        }),
        {
            name: 'owners-storage',
            partialize: (state) => ({ owners: state.owners }),
        },
    ),
);
